"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import Formatter from "@/framework/timeformatter";
import API from "@ym-framework/api-utils";
import _ from "lodash";
class LoginLogSearchData {
  constructor() {
    this.operatorName = "";
    this.loginIp = "";
    this.loginRegion = "";
    this.expiryDate = new Array();
  }
}
let LoginLogsAdvancedSearch = class extends Vue {
  constructor() {
    super(...arguments);
    this.viewShow = true;
    this.resultShow = false;
    this.formData = new LoginLogSearchData();
    this.searchList = new Array();
    this.pickerOptions = {
      shortcuts: [{
        text: this.$t("loginlogs.nearweeks"),
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }]
    };
    this.regions = null;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      console.dir(this.formData);
      this.searchList = new Array();
      let searchData = new Object();
      if (!this.isEmptyString(this.formData.operatorName)) {
        searchData["operatorName"] = this.formData.operatorName;
        this.searchList.push({
          name: "operatorName",
          title: this.$t("order.applicant"),
          content: this.formData.operatorName
        });
      }
      if (this.formData.expiryDate.length === 2) {
        searchData["start_time"] = this.formData.expiryDate[0];
        searchData["end_time"] = this.formData.expiryDate[1];
        this.searchList.push({
          name: "expiryDate",
          title: this.$t("loginlogs.login_time"),
          content: `${Formatter.dateformatDay(Formatter.check(this.formData.expiryDate[0]))} - ${Formatter.dateformatDay(Formatter.check(this.formData.expiryDate[1]))}`
        });
      }
      if (!this.isEmptyString(this.formData.loginIp)) {
        searchData["loginIp"] = this.formData.loginIp;
        this.searchList.push({
          name: "loginIp",
          title: this.$t("loginlogs.login"),
          content: this.formData.loginIp
        });
      }
      if (!this.isEmptyString(this.formData.loginRegion)) {
        searchData["loginRegion"] = this.formData.loginRegion;
        this.searchList.push({
          name: "loginRegion",
          title: this.$t("loginlogs.login_area"),
          content: this.formData.loginRegion
        });
      }
      this.$emit("advancedSearch", searchData);
    });
  }
  reset(isClose) {
    this.formData.operatorName = "";
    this.formData.loginIp = "";
    this.formData.expiryDate = new Array();
    this.formData.loginRegion = "";
    this.searchList = new Array();
    if (isClose) {
      this.$emit("advancedSearchClear", "close");
    } else {
      this.$emit("advancedSearchClear", "clear");
    }
  }
  clear(key) {
    this.$set(this.formData, key, Object(new LoginLogSearchData())[key]);
    this.searchList = _.filter(this.searchList, (item) => {
      return item.name !== key;
    });
    this.submit();
  }
  isEmptyString(str) {
    if (str === "" || str === null || str === void 0) {
      return true;
    } else {
      return false;
    }
  }
  open() {
    return __async(this, null, function* () {
      if (this.viewShow) {
        this.close();
        return;
      }
      this.viewShow = true;
      yield this.getRegions();
    });
  }
  close() {
    this.viewShow = false;
    this.reset(true);
  }
  getRegions() {
    return __async(this, null, function* () {
      this.regions = null;
      let response = yield API.get(`api://base.auth/api/v7/loginLogs/region`);
      this.regions = response.data.datas;
      console.log(this.regions);
    });
  }
};
LoginLogsAdvancedSearch = __decorateClass([
  Component
], LoginLogsAdvancedSearch);
export {
  LoginLogsAdvancedSearch as default
};
